const state = {
  // 模块名，path 的第一部分，例如 /main/order_orderdList中的 main  或 /wxwork 中的 wxwork
  navModule: sessionStorage.navModule || 'home',
  navIndex: Number(sessionStorage.navIndex),
  userRole: 1,
  // 企业微信中使用的
  wwContext: {
    appEntry: '', // 企业微信入口，例如 single_chat_tools/group_chat_tools...
    contactUserId: '', // 企业微信外部联系人用户id
    contactCorpId: '', // 企业微信外部联系人所属corpid
    contactType: '',
    contactBindCusId: '',
    groupChatId: '' // 企业微信群聊id
  },
  // 企业微信外部联系人信息, 参见 https://developer.work.weixin.qq.com/document/path/92265
  // ！！！注意：此字段可能不存在（当不是单聊界面时就和获取不到）
  wwContact: {
    external_contact: {
      external_userid: '',
      name: '',
      type: 0,
      gender: 0,
      // 以下字段不一定能获取到
      position: '', // 外部联系人职务
      avatar: '', // 外部联系人头像，第三方不可获取, 代开发自建应用需要管理员授权才可以获取
      corp_name: '', // 外部联系人所在企业的简称，仅当联系人类型是企业微信用户时有此字段
      corp_full_name: '', // 外部联系人所在企业的全称，仅当联系人类型是企业微信用户时有此字段
      unionid: '', // 外部联系人在微信开放平台的唯一身份标识（微信unionid），通过此字段企业可将外部联系人与公众号/小程序用户关联起来。仅当联系人类型是微信用户，且企业绑定了
      external_profile: {} // 外部联系人的自定义展示信息，可以有多个字段和多种类型，包括文本，网页和小程序，仅当联系人类型是企业微信用户时有此字段
    },
    // 数组，添加加了此外部联系人的企业成员信息
    follow_user: [{
      userid: '',
      remark: '',
      description: '',
      createtime: '',
      tags: [{
        group_name: '',
        tag_id: '',
        type: 0,
        name: ''
      }, {
        group_name: '',
        tag_id: '',
        type: 0,
        tag_name: ''

      }],
      remark_corp_name: '',
      remark_mobiles: ''
    }]
  },
  // 业务系统客户联系人信息，参见业务系统接口 /mapi/customer/contact/wxwork-get
  // ！！！注意：此字段可能不存在（外部联系人未与业务系统绑定则没有），可通过cppContact为空或cppContact.contact_id为空来判断是否已经绑定
  // 包含字段:
  //   store_id: 0,
  //   log_id: 0,
  //   contact_id: 0,
  //   contact_name: '',
  //   contact_tel: '',
  //   cus_id: 0,
  //   cus_name: '',
  //   status: 0
  cppContact: {
    store_id: 0,
    log_id: 0,
    contact_id: 0,
    contact_name: '',
    contact_tel: '',
    cus_id: 0,
    cus_name: '',
    cus_hash: '',
    status: 0
  }

}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js